export const FileTypes = {
  IMG: 'IMG',
  MOVIE: 'MOVIE',
  DOCUMENT: 'DOCUMENT',
  AUDIO: 'AUDIO',
  OTHER: 'OTHER'
};
export const IMG_TYPES = ['jpg', 'jpeg', 'png', 'gif', 'tif', 'tiff', 'ico', 'bmp', 'webp', 'svg'];
export const MOVIE_TYPES = ['mov', 'avi', 'flv', 'wmv', 'rm', '3gp', '3g2', 'asf', 'asx', 'mpg', 'mp4', 'mpeg', 'swf', 'm4v', 'webm'];
export const DOCUMENT_TYPES = ['csv', 'doc', 'docx', 'dot', 'dotx', 'key', 'md', 'pdf', 'pot', 'potx', 'pps', 'ppsx', 'ppt', 'pptx', 'txt', 'wpd', 'wps', 'wri', 'xls', 'xlsb', 'xlsx', 'xlt', 'xlx', 'xml'];
export const AUDIO_TYPES = ['aac', 'aif', 'm4a', 'mp3', 'mpa', 'ra', 'wav', 'wma'];
export const TypeToExtensions = {
  [FileTypes.IMG]: [...IMG_TYPES],
  [FileTypes.MOVIE]: [...MOVIE_TYPES],
  [FileTypes.DOCUMENT]: [...DOCUMENT_TYPES],
  [FileTypes.AUDIO]: [...AUDIO_TYPES]
};
const TEXT_THUMBNAILS_EXTENSIONS = ['txt', 'log', 'csv', 'xml', 'js', 'rtf', 'css', 'json'];
export const WORD_EXTENSIONS = ['doc', 'docx'];
export const EXCEL_EXTENSIONS = ['xls', 'xlsx', 'csv'];
export const POWERPOINT_EXTENSIONS = ['ppt', 'pptx'];
export const HTML_EXTENSIONS = ['html', 'xhtml'];
export const GRAPHQL_EXTENSIONS = ['gql', 'graphql'];
export const CALL_TRANSCRIPT_EXTENSIONS = ['webvtt', 'vtt'];
export const RENDERED_FILE_THUMBNAILS_EXTENSIONS = [...HTML_EXTENSIONS];
export const OFFICE_FILE_THUMBNAILS_EXTENSIONS = ['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'msg', 'odt'];
export const ALLOWED_THUMBNAILS_EXTENSIONS = ['pdf', ...TEXT_THUMBNAILS_EXTENSIONS, ...RENDERED_FILE_THUMBNAILS_EXTENSIONS, ...OFFICE_FILE_THUMBNAILS_EXTENSIONS];